import { ICodReview } from '.';
import {
    IssueType,
    Through,
    NatureOfComplaintDomestic,
    RootCause,
    ReviewResult,
    ReviewNextStep
} from '../../../../enums';

export interface IInvestigatorReviewDom extends ICodReview {
    natureOfComplaint?: NatureOfComplaintDomestic;
    rootCause?: RootCause;
    issueType?: IssueType;
    through?: Through;
    csrResponsible?: string;
    details?: string;
    reviewResult: ReviewResult;
    nextStep?: ReviewNextStep;
}
